import React from 'react';
import { Route } from 'react-router-dom';

import { TrackedRoutes } from '../../components/TrackedRoutes';

import { SupplierCreate } from './components/SupplierCreate/SupplierCreate';
import { SupplierList } from './components/SupplierList/SupplierList';
import { SupplierProfile } from './components/SupplierProfile/SupplierProfile';

export const SuppliersPage: React.FC = () => {
  return (
    <TrackedRoutes>
      <Route index element={<SupplierList />} />
      <Route path="create" element={<SupplierCreate />} />
      <Route path=":supplierId" element={<SupplierProfile />} />
    </TrackedRoutes>
  );
};
